module.exports = __webpack_public_path__ + "img/GrüneBrücke.cc5b8b95.svg";